import React from 'react'
import MultipleSelectWithOrder from "features/Admin/components/MultipleSelectWithOrder";

const AnswersForm = ({ element, answersFactory }) => (

    <div>
        <MultipleSelectWithOrder factory={answersFactory}/>
    </div>


)

export default AnswersForm